module.exports = __webpack_public_path__ + "img/zhuoQRcode.4584fe1a.jpg";